import React, { useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Dropdown } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import GroupAddOutlinedIcon from "@material-ui/icons/GroupAddOutlined";
import AddIcon from "@material-ui/icons/Add";
// import InsertInvitationOutlinedIcon from "@material-ui/icons/InsertInvitationOutlined";
import { Card } from "react-bootstrap";
import MuiAlert from "@material-ui/lab/Alert";
import { AssignCoach } from "./AssignCoach";
import SeeCoach from "./SeeCoach";
import { SeeClients } from "./SeeClients";

import {
  TablePagination,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Box,
  makeStyles,
  Typography,
  ButtonGroup,
  InputBase,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Snackbar,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { FetchUsersList, AssignNewCoach, FetchOrganizations, AddOrganization, UpdateOrganization } from "../apis";
import { ClientProfile } from "./ClientProfile";

// users list
const GET_USERS_LIST = gql`
  query Query(
    $getAllUsersListPageNo: Int
    $getAllUsersListLimit: Int
    $getAllUsersListSearchText: String
  ) {
    getAllUsersList(
      pageNo: $getAllUsersListPageNo
      limit: $getAllUsersListLimit
      searchText: $getAllUsersListSearchText
    ) {
      usersList {
        id
        firstName
        lastName
        email
        isBlocked
        type
        invitedBy
      }
      usersCount
      pageNo
    }
  }
`;

// add client
const ADD_CLIENT = gql`
  mutation Mutation(
    $sendCoachInvitationEmail: String!
    $sendCoachInvitationFirstName: String!
    $sendCoachInvitationLastName: String!
    $sendCoachInvitationType: String!
  ) {
    sendCoachInvitation(
      email: $sendCoachInvitationEmail
      firstName: $sendCoachInvitationFirstName
      lastName: $sendCoachInvitationLastName
      type: $sendCoachInvitationType
    ) {
      code
      success
      message
    }
  }
`;
// block mutation
const BLOCK_USER = gql`
  mutation Mutation($blockUserUserId: String) {
    blockUser(userId: $blockUserUserId) {
      code
      success
      message
    }
  }
`;

const UNBLOCK_USER = gql`
  mutation Mutation($unblockUserUserId: String) {
    unblockUser(userId: $unblockUserUserId) {
      code
      success
      message
    }
  }
`;
// unblock mutation

// css
const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  table: {
    minWidth: 1050,
  },
  tableHeadCell: {
    fontSize: "18px",
  },
  tableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "40px",
    align: "left",
  },
  dropdown: {
    position: "absolute",
    top: 28,
    right: 0,
    left: 0,
    zIndex: 1,
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#f2f2f2",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    fontSize: "14px",
  },
  inputInput: {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));
// end of css

let headers = [
  "Org. Name",
  "First/Last Name",
  "Phone",
  "Email",
  "Industry",
  "No. of Employees",
  "See",
  "Action",
];

// let rows = [];
let count;
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export function ClientListTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearchText] = React.useState("");
  const [DialogState, setDialogState] = React.useState(false);
  const [userId, setUserIdForBlock] = React.useState("");
  const [blockedUser, setUserNameForBlock] = React.useState("");
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = React.useState("");
  const [sort, setSort] = React.useState(1);
  const [seeUserDetail, setUserDetail] = useState(false);
  // const [count, setCount] = useState()

  const { data, refetch } = useQuery(GET_USERS_LIST, {
    variables: {
      getAllUsersListPageNo: page,
      getAllUsersListLimit: rowsPerPage,
      getAllUsersListSearchText: search,
    },
  });

  const [snackBarText, setSnackBarText] = React.useState("");
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackBarVariant, setSnackBarVariant] = React.useState("success");

  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [userType, setUserType] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [website, setWebsite] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [industry, setindustry] = React.useState("");
  const [companySize, setCompanySize] = React.useState(0)
  const [totalEmployees, setTotalEmployees] = React.useState(0)
  const [mainContact, setMainContact] = React.useState({
    firstName: '',
    lastName: ''
  })


  const [addClientLoader, setAddClientLoader] = React.useState(false);
  const [assigningCoach, setAssigningCoach] = React.useState(false);
  const [assignCoach, setAssignCoach] = React.useState(false);
  const [seeCoach, setSeeCoach] = React.useState(false);
  const [seeJobSeeker, setSeeJobSeeker] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState("");
  const [selectedJs, setSelectedJs] = React.useState();
  const [seeUserModal, setSeeUserModal] = React.useState(false);

  const [addClient] = useMutation(ADD_CLIENT, {
    onCompleted(addClient) {
      setSnackBarVariant("success");
      setSnackBarText("Invitation sent successfully");
      setSnackBarOpen(true);
      setAddClientLoader(false);
      setDialogState(false);
      fetchUsers(page, rowsPerPage, search, sort, filter);
    },
  });
  const [blockUser] = useMutation(BLOCK_USER, {
    variables: {
      blockUserUserId: userId,
    },
    onCompleted() {
      fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("error");
      setSnackBarText("you have blocked " + blockedUser);
      setSnackBarOpen(true);
    },
  });

  const [unBlockUser] = useMutation(UNBLOCK_USER, {
    variables: {
      unblockUserUserId: userId,
    },
    onCompleted() {
      fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("success");
      setSnackBarText("you have unblocked " + blockedUser);
      setSnackBarOpen(true);
    },
  });

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const searchText = (event) => {
    setSearchText(event.target.value);


    fetchUsers(page, rowsPerPage, event.target.value, sort, filter);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchUsers(newPage, rowsPerPage, search, sort, filter);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    // fetchUsers();
  };

  const handleDialogOpen = () => {
    setDialogState(true);
  };

  const handleDialogClose = () => {
    setDialogState(false);
  };
  const classes = useStyles();

  const handleBlock = async (id, name) => {
    setUserIdForBlock(id);
    setUserNameForBlock(name);
    let res = await UpdateOrganization(id, { isBlocked: true })
    setUserIdForBlock("");
    setUserNameForBlock("")
    setSnackBarVariant("error");
    setSnackBarText("you have blocked " + blockedUser);
    setSnackBarOpen(true);
    fetchUsers(page, rowsPerPage, search, sort, filter);
    // blockUser({
    //   variables: { blockUserUserId: id },
    // });
  };
  const handleUnBlock = async (id, name) => {
    setUserNameForBlock(name);

    setUserIdForBlock(id);
    let res = await UpdateOrganization(id, { isBlocked: false })
    setUserNameForBlock("")
    setUserIdForBlock("");
    setSnackBarVariant("error");
    setSnackBarText("you have Unblocked " + blockedUser);
    setSnackBarOpen(true);
    fetchUsers(page, rowsPerPage, search, sort, filter);
    // unBlockUser({
    //   variables: { unblockUserUserId: id },
    // });
  };
  // const handleFirstName = (evt) => {
  //   setFirstName(evt.target.value);
  // };
  // const handleLastName = (evt) => {
  //   setLastName(evt.target.value);
  // };
  // const handleEmail = (evt) => {
  //   setEmail(evt.target.value);
  // };

  const hanldeUserType = (evt) => {
    setUserType(evt.target.value);
  };
  const handleAddClient = async () => {
    setAddClientLoader(true);

    let data = {
      name,
      mainContact,
      phone,
      email,
      totalEmployees,
      companySize,
      website,
      address,
      industry
    }
    let res = await AddOrganization(data)
    setSnackBarVariant("success");
    setSnackBarText("Invitation sent successfully");
    setSnackBarOpen(true);
    setAddClientLoader(false);
    setDialogState(false);
    fetchUsers(page, rowsPerPage, search, sort, filter);
    // addClient({
    //   variables: {
    //     sendCoachInvitationEmail: email,
    //     sendCoachInvitationFirstName: firstName,
    //     sendCoachInvitationLastName: lastName,
    //     sendCoachInvitationType: userType,
    //   },
    // });
  };

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };

  // if (typeof data === "object") {
  //   count = parseInt(data.getAllUsersList.usersCount);
  //   rows = data.getAllUsersList.usersList.map((key) => {
  //     var blockStatus;
  //     if (key.isBlocked) {
  //       blockStatus = "Blocked";
  //     } else {
  //       blockStatus = "Active";
  //     }
  //     console.log("key:-=-=", key)
  //     return {
  //       id: key.id,
  //       name: key.firstName + " " + key.lastName,
  //       email: key.email,
  //       phone: "N/A",
  //       stage: "Needs Resume Review",
  //       status: blockStatus,
  //       action: key.isBlocked,
  //       type: key.type === "JOB_SEEKER" ? 'Job Seeker' : "Coach"
  //     };
  //   });
  // }

  React.useEffect(() => {
    fetchUsers(page, rowsPerPage, search, sort, filter);
  }, {});

  const fetchUsers = async (p, r, s, st, f) => {
    let result = await FetchOrganizations(p, r, s, st, f === "All" ? "" : f);
    console.log("result: ", result.data);
    let newRows = result.data.organizations.map((key) => {
      var blockStatus;
      if (key.isBlocked) {
        blockStatus = "Blocked";
      } else {
        blockStatus = "Active";
      }
      console.log("key:-=-=", key);
      return {
        id: key._id,
        name: key.name,
        mainContact: key.mainContact,
        email: key.email,
        phone: key.phone,
        status: blockStatus,
        action: key.isBlocked,
        address: key.address,
        totalEmployees: key.totalEmployees,
      };
    });

    setRows([...newRows]);
    count = result.data.count;
  };

  const onSelectCategory = (evt) => {
    setFilter(evt.target.value);
    fetchUsers(page, rowsPerPage, search, sort, evt.target.value);
  };


  const closeAssignCoach = () => {
    setAssignCoach(false);
    setSelectedJs(undefined);
  };

  const onAssigngingCoach = async (data) => {
    setAssigningCoach(true);
    let update = await AssignNewCoach(data);
    closeAssignCoach();
    setAssigningCoach(false);
    fetchUsers(page, rowsPerPage, search, sort, filter);
  };

  const closeSeeClientPopup = () => {
    setSeeJobSeeker(false);
    setSelectedUser("");
  };

  const closeUserDetails = (data) => {
    setSeeUserModal(false);
    setSelectedJs(undefined);
  };

  return (
    <Card className="shadow-sm">
      <Card.Body>
        <Grid container direction="columnm" className="px-5">
          <Grid container direction="row" justify="space-between">
            <Grid item>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  placeholder="Search client by name, email and phone"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  inputProps={{ "aria-label": "search" }}
                  onChange={searchText}
                />
              </div>
            </Grid>
            <Grid item>
              <FormControl
                style={{
                  width: 130,
                  marginTop: -5,
                }}
              >
                <InputLabel id="demo-simple-select-label1">
                  Select Category
                </InputLabel>
                <Select
                  label="filter"
                  labelId="demo-simple-select-label1"
                  id="demo-simple-select"
                  value={filter}
                  onChange={onSelectCategory}
                >
                  <MenuItem value="All" selected>
                    All
                  </MenuItem>
                  <MenuItem value="BLOCKED">Blocked Users</MenuItem>
                  <MenuItem value="UNBLOCKED">UnBlocked Users</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <div>
                <div>
                  <FormControl
                    style={{
                      marginTop: -5,
                    }}
                  >
                    <InputLabel id="demo-simple-select-label">
                      Select Sort
                    </InputLabel>
                    <Select
                      label="filter"
                      // className="form-control border-0 form-control-solid py-5 px-6 my-3"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={sort}
                      onChange={(evt) => {
                        setSort(evt.target.value);
                        fetchUsers(
                          page,
                          rowsPerPage,
                          search,
                          evt.target.value,
                          filter
                        );
                      }}
                    >
                      <MenuItem value={1}>Ascending Order</MenuItem>
                      <MenuItem value={-1}>Descending Order</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                className={classes.button}
                startIcon={<AddIcon style={{ fontSize: 25 }} />}
                onClick={handleDialogOpen}
              >
                <Typography className="px-3" variant="h6">
                  Add Organization
                </Typography>
              </Button>
            </Grid>
          </Grid>
          <Grid item>
            <Snackbar
              open={snackBarOpen}
              autoHideDuration={5000}
              onClose={handleSnackBarClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Alert
                onClose={handleSnackBarClose}
                style={{
                  fontSize: "16px",
                  backgroundColor: snackBarVariant === "error" ? "red" : "",
                }}
                severity={snackBarVariant}
              >
                {snackBarText}
              </Alert>
            </Snackbar>
          </Grid>
          <Grid item>
            <Dialog
              open={DialogState}
              onClose={handleDialogClose}
              aria-labelledby="form-dialog-title"
              maxWidth="sm"
              fullWidth="100%"
            >
              <DialogTitle id="form-dialog-title">
                <Typography variant="h6">ADD NEW ORGANIZATION</Typography>
              </DialogTitle>
              <DialogContent>
                <input
                  className="form-control form-control-solid h-auto py-5 px-6 my-3"
                  autoFocus
                  margin="dense"
                  placeholder="Name"
                  value={name}
                  onChange={(evt) => setName(evt.target.value)}
                />
                <input
                  className="form-control form-control-solid h-auto py-5 px-6 my-3"
                  margin="dense"
                  placeholder="Address"
                  value={address}
                  onChange={(evt) => setAddress(evt.target.value)}
                  required
                />
                <Grid
                  // className="px-5 mb-4"
                  container
                  direction="row"
                  justify="space-between"
                  spacing={2}
                >
                  <Grid item md={6}>
                    <input
                      className="form-control form-control-solid h-auto w-100 py-5 px-6"
                      margin="dense"
                      placeholder="Contact First Name"
                      name='firstName'
                      value={mainContact.firstName}
                      onChange={(evt) => setMainContact({ ...mainContact, firstName: evt.target.value })}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <input
                      className="form-control form-control-solid h-auto py-5 px-6"
                      margin="dense"
                      placeholder="Contact Last Name"
                      name='lastName'
                      value={mainContact.lastName}
                      onChange={(evt) => setMainContact({ ...mainContact, lastName: evt.target.value })}
                    />
                  </Grid>
                </Grid>
                <Grid
                  // className="px-5 mb-4"
                  container
                  direction="row"
                  justify="space-between"
                  spacing={2}
                >
                  <Grid item md={6}>
                    <input
                      className="form-control form-control-solid h-auto w-100 py-5 px-6"
                      margin="dense"
                      placeholder="Phone"
                      value={phone}
                      onChange={(evt) => setPhone(evt.target.value)}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <input
                      className="form-control form-control-solid h-auto py-5 px-6"
                      margin="dense"
                      placeholder="Email"
                      type="email"
                      value={email}
                      onChange={(evt) => setEmail(evt.target.value)}
                      required

                    />
                  </Grid>
                </Grid>
                <Grid
                  // className="px-5 mb-4"
                  container
                  direction="row"
                  justify="space-between"
                  spacing={2}
                >
                  <Grid item md={6}>
                    <input
                      className="form-control form-control-solid h-auto w-100 py-5 px-6"
                      margin="dense"
                      placeholder="Comapny Size"
                      type="number"
                      value={companySize}
                      onChange={(evt) => setCompanySize(evt.target.value)}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <input
                      className="form-control form-control-solid h-auto py-5 px-6"
                      margin="dense"
                      placeholder="Industry"
                      value={industry}
                      onChange={(evt) => setindustry(evt.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid
                  // className="px-5 mb-4"
                  container
                  direction="row"
                  justify="space-between"
                  spacing={2}
                >
                  <Grid item md={6}>
                    <input
                      className="form-control form-control-solid h-auto w-100 py-5 px-6"
                      margin="dense"
                      placeholder="Wesbite"
                      value={website}
                      onChange={(evt) => setWebsite(evt.target.value)}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <input
                      className="form-control form-control-solid h-auto py-5 px-6"
                      margin="dense"
                      placeholder="No. of employees"
                      type="number"
                      value={totalEmployees}
                      onChange={(evt) => setTotalEmployees(evt.target.value)}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Grid
                  className="px-5 mb-4"
                  container
                  direction="row"
                  justify="space-between"
                >
                  <Grid item>
                    <Button
                      size="large"
                      onClick={handleDialogClose}
                      variant={"contained"}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      size="large"
                      onClick={handleAddClient}
                      color="secondary"
                      variant={"contained"}
                      className="px-10"
                      disabled={
                        name.length && phone.length && email.length
                          ? false
                          : true
                      }
                    >
                      {addClientLoader ? (
                        <CircularProgress
                          size="20px"
                          style={{ color: "#ffffff" }}
                        />
                      ) : (
                        <Typography>Add</Typography>
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>

        <TableContainer className="mt-10">
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headers.map((item, index) => (
                  <TableCell
                    key={index}
                    align="left"
                    classes={{ root: classes.tableHeadCell }}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {rows && rows.length > 0 && rows.map((r) => {
                return (
                  <StyledTableRow>
                    <TableCell
                      classes={{
                        root: classes.tableRowCell,
                      }}
                      component="th"
                      scope="row"
                      align="left"
                    >
                      {r.name}
                    </TableCell>
                    <TableCell align="left">{r.mainContact.firstName} {r.mainContact.lastName}</TableCell>
                    <TableCell align="left">{r.phone}</TableCell>
                    <TableCell align="left">{r.email}</TableCell>
                    <TableCell align="left">{r.industry}</TableCell>
                    <TableCell
                      align="left"
                      classes={{ root: classes.tableRowCell }}
                    >
                      {r.totalEmployees}
                    </TableCell>
                    <TableCell
                      align="left"
                      classes={{ root: classes.tableRowCell }}
                    >
                      <Button
                        variant="outlined"
                        onClick={() => setUserDetail(true)}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#28d604",
                          borderColor: "#28d604",
                          // width: 'max-content'
                        }}
                      >
                        <Typography>See Client</Typography>
                      </Button>
                    </TableCell>
                    <TableCell
                      align="left"
                      classes={{ root: classes.tableRowCell }}
                    >
                      {r.action ? (
                        <Button
                          variant="outlined"
                          onClick={() => {
                            handleUnBlock(r.id, r.name);
                          }}
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#28d604",
                            borderColor: "#28d604",
                          }}
                        >
                          {userId === r.id ? (
                            <CircularProgress size="17px" className="mx-7 " />
                          ) : (
                            <Typography>Unblock</Typography>
                          )}
                        </Button>
                      ) : (
                        <Button
                          variant="outlined"
                          style={{
                            borderColor: "#fc7e7e",
                            color: "#fc7e7e",
                            backgroundColor: "#ffffff",
                          }}
                          onClick={() => {
                            handleBlock(r.id, r.name);
                          }}
                          className="pl-7 pr-8"
                        >
                          {userId === r.id ? (
                            <CircularProgress
                              size="18px"
                              style={{ color: "#fc7e7e" }}
                              className="mx-4 "
                            />
                          ) : (
                            <Typography>Block</Typography>
                          )}
                        </Button>
                      )}
                    </TableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
            <TablePagination
              count={count}
              page={page}
              onChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Table>
        </TableContainer>
        {/* see client popup */}
        <Grid item>
          <Dialog
            open={seeUserDetail}
            onClose={() => setUserDetail(false)}
            // aria-labelledby="form-dialog-title"
            maxWidth="lg"
            fullWidth="100%"
          >
            <DialogContent className="py-15">
              <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      {headers.map((item, index) => (
                        <TableCell
                          key={index}
                          align="left"
                          classes={{ root: classes.tableHeadCell }}
                        >
                          {item}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    <StyledTableRow>
                      <TableCell
                        classes={{
                          root: classes.tableRowCell,
                        }}
                        component="th"
                        scope="row"
                        align="left"
                      >
                        Alex Costa
                      </TableCell>
                      <TableCell align="left">alex@mail.com</TableCell>
                      <TableCell align="left">+1 913 123 4567</TableCell>
                      <TableCell align="left">Stage</TableCell>
                      <TableCell align="left">Industry</TableCell>
                      <TableCell
                        align="left"
                        classes={{ root: classes.tableRowCell }}
                      >
                        1000+
                      </TableCell>
                      <TableCell
                        align="left"
                        classes={{ root: classes.tableRowCell }}
                      >
                        <Button
                          variant="outlined"
                          onClick={() => null}
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#28d604",
                            borderColor: "#28d604",
                            // width: 'max-content'
                          }}
                        >
                          <Typography>See Client</Typography>
                        </Button>
                      </TableCell>
                      <TableCell
                        align="left"
                        classes={{ root: classes.tableRowCell }}
                      >
                        <Button
                          variant="outlined"
                          style={{
                            borderColor: "#fc7e7e",
                            color: "#fc7e7e",
                            backgroundColor: "#ffffff",
                          }}
                          className="pl-7 pr-8"
                        >
                          <Typography>Block</Typography>
                        </Button>
                      </TableCell>
                    </StyledTableRow>
                  </TableBody>
                  <TablePagination
                    count={count}
                    page={page}
                    onChangePage={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </Table>
              </TableContainer>
            </DialogContent>
          </Dialog>
        </Grid>
        {assignCoach && (
          <AssignCoach
            selectedJobSeeker={selectedJs}
            open={AssignCoach}
            onClose={closeAssignCoach}
            onAssigngingCoach={onAssigngingCoach}
          />
        )}
        {seeJobSeeker && (
          <SeeClients
            open={seeJobSeeker}
            onClose={closeSeeClientPopup}
            selectedUser={selectedUser}
          />
        )}
        {seeUserModal && selectedJs && (
          <ClientProfile
            user={selectedJs}
            onClose={closeUserDetails}
            open={seeUserModal}
          />
        )}
      </Card.Body>
    </Card>
    // </Box>
  );
}
